import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@core/services/auth.service';
import { AccessStateService } from '@core/services/access-state.service';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

export const authGuard: CanActivateFn = (
  _: ActivatedRouteSnapshot,
  __: RouterStateSnapshot
): Observable<boolean> => {
  const authService = inject(AuthenticationService);
  const accessStateService = inject(AccessStateService);
  const router = inject(Router);

  return authService.check().pipe(
    switchMap((data) => {
      if (!data.ok) {
        router.navigate(['/']);
        return of(false);
      }

      return accessStateService.refresh().pipe(
        map(() => true),
        catchError(() => of(true)),
      );
    }),
    catchError((err) => {
      // Un 401 aquí significa que el interceptor ya intentó renovar el
      // token vía /auth/refresh y no pudo: la sesión de verdad terminó.
      // Cualquier otro fallo (red caída, 5xx puntual, timeout) no dice nada
      // sobre la sesión y no debe expulsar al usuario en mitad de su trabajo.
      if (err instanceof HttpErrorResponse && err.status === 401) {
        router.navigate(['/']);
        return of(false);
      }
      return of(true);
    })
  );
};
